import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const addBadgesAsync = createAsyncThunk(
  "admin/addBadges",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addBadges`, payload, toolkit);
  }
);

export const getAllBadgesAsync = createAsyncThunk(
  "admin/getAllBadges",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllBadges?page=${payload.page || ""}&limit=${payload.limit || ""}`,
      [],
      toolkit
    );
  }
);

export const getBadgesByIdAsync = createAsyncThunk(
  "admin/getBadgesById",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getBadgesById/${payload}`, [], toolkit);
  }
);

export const updateBadgesByIdAsync = createAsyncThunk(
  "admin/updateBadgesById",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateBadgesById`, payload, toolkit);
  }
);

export const deleteBadgesByIdAsync = createAsyncThunk(
  "admin/deleteBadgesById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteBadgesById/${payload}`,
      [],
      toolkit
    );
  }
);
